import styled from 'styled-components';

export const ObsFeelsLike = styled.div`
    display: flex;
    flex-direction: row;
    height: 48%;
    width: 100%;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
`;
